import React from "react";
import Buttons from "../../../components/ui/button/Buttons";
import { decryptAESID, encryptAESID } from "../../../utils/Encryption";
import { useParams } from "react-router-dom";
import { useLazyGetCPDEventByCpdEventIdQuery } from "../../../app/services/GMPCourseProvider/GMPCoursePoviderApi";

const RelatedEvent = (props) => {
    const { id } = useParams();
    const editID = id ? decryptAESID(id, false) : 0;
    const [getCPDEventByCpdEventId] = useLazyGetCPDEventByCpdEventIdQuery();

    const handleClick = async () => {
        try {
            const result = await getCPDEventByCpdEventId(editID).unwrap();
            if (result?.approveCPDEventTypeId) {
                const encryptedId = encryptAESID(result.approveCPDEventTypeId);
                window.open(`/editCpdEvent/${encryptedId}`, '_blank');
            }
        } catch (error) {
            console.error("Failed to fetch CPD event:", error);
        }
    };

    return (
        <Buttons
            buttonText={"Related Event"}
            buttonTypeClassName="btn btn-primary ml-2 mt-0"
            onClick={handleClick}
        />
    );
};

export default RelatedEvent;
